import { useCallback } from 'react'
import { updateFunkActor } from '../api/actuators.api'
import { useDispatch } from 'react-redux'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { refreshApiView } from '@e3dc-react/shell/State/ApiView/ApiViewActions'
import { Actuator, ActuatorPayload } from '../models/smart-home.model'
import { useSnackbar } from '@e3dc-react/shell/Hooks/Snackbar'

interface Props {
  setIsLoading: (loading: boolean) => void
}

export const useActuatorUpdate = ({
  setIsLoading,
}: Props): ((serialNo: number, actuator: Actuator, payload: ActuatorPayload, timerDuration?: number) => void) => {
  const dispatch = useDispatch()
  const authFetch = useAuthFetchWithResponse()
  const { t } = useCustomTranslation()
  const { enqueueSuccessStack, enqueueErrorStack } = useSnackbar()

  return useCallback(
    (serialNo: number, actuator: Actuator, payload: ActuatorPayload, timerDuration = 800) => {
      if (!serialNo) return
      setIsLoading(true)

      updateFunkActor(serialNo.toString(), actuator.index, payload, authFetch)
        .then(result => {
          if (result.hasErrors) {
            setIsLoading(false)
            dispatch(refreshApiView())
            enqueueErrorStack(t(result.error?.message ?? 'smart-home.save-error'))
            console.error('Error updating actuator:', result.error)
            return
          }

          enqueueSuccessStack(t('smart-home.save-success'))
          setTimeout(() => {
            setIsLoading(false)
            dispatch(refreshApiView())
          }, timerDuration)
        })
        .catch(error => {
          setIsLoading(false)
          dispatch(refreshApiView())
          enqueueErrorStack(t('smart-home.save-error'))
          console.error('Error updating actuator:', error)
        })
    },
    [authFetch, dispatch, enqueueErrorStack, enqueueSuccessStack, setIsLoading, t]
  )
}
